import { combineReducers } from 'redux';
import webAppointmentForm from '../webappointment/reducers/webAppointmentReducer';

// combines all reducers
// name here is used for the key for all related state properties
const rootReducer = combineReducers({
  webAppointmentForm
});

export default rootReducer;
